export const styles = {
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    height: '600px',
    width: '100%',
    '@media (max-width: 780px)': {
      flexDirection: 'column-reverse',
    },
  },
  textContainer: {
    flex: 1,
    padding: '60px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: '30px',
    '@media (max-width: 780px)': {
      flex: 'none',
      padding: '30px',
      height: '50%',
      gap: '30px',
    },
  },
  textContent: {
    maxWidth: '568px',
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    '@media (max-width: 780px)': {
      gap: '5px',
    },
  },
  imageContainer: {
    width: '50%',
    overflow: 'hidden',
    '@media (max-width: 780px)': {
      width: '100%',
      height: '50%',
    },

    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  },
  icon: {
    color: '#fff',
    position: 'absolute',
    width: '50px',
    height: '50px',
    right: 0,
    top: 0,
    marginTop: '20px',
    marginRight: '20px',
    zIndex: 1,
    backgroundColor: 'rgba(36,37,40,0.3)',
    '@media (max-width: 780px)': {
      width: '40px',
      height: '40px',
      marginTop: '14px',
      marginRight: '14px',
    },
  },
  title: {
    fontFamily: 'Poppins',
    fontWeight: '700',
    fontSize: '70px',
    lineHeight: 1,
    color: '#E36720',
    textTransform: 'uppercase',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word',
    '@media (max-width: 1200px)': {
      fontSize: '60px',
      lineHeight: 1,
    },
    '@media (max-width: 780px)': {
      fontSize: '28px',
    },
  },
  type: {
    fontFamily: 'Poppins',
    fontWeight: '500',
    fontSize: '30px',
    lineHeight: 1,
    color: '#242528',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word',
    '@media (max-width: 1200px)': {
      fontSize: '25px',
    },
    '@media (max-width: 780px)': {
      fontSize: '20px',
    },
  },
  description: {
    fontFamily: 'Poppins',
    fontWeight: '400',
    fontSize: '24px',
    lineHeight: 1,
    color: '#53575D',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 3,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word',
    '@media (max-width: 1200px)': {
      fontSize: '20px',
    },
    '@media (max-width: 780px)': {
      fontSize: '16px',
    },
  },
  button: {
    alignSelf: 'flex-start',
    width: '100%',
    fontFamily: 'Poppins',
    fontSize: '24px',
    fontWeight: '500',
    lineHeight: 1,
    textTransform: 'none',
    color: '#fff',
    paddingY: '16px',
    borderRadius: '9.2px',
    backgroundColor: '#E36720',
    ':hover': {
      backgroundColor: '#E36720',
    },
    '@media (max-width: 780px)': {
      fontSize: '18px',
      lineHeight: 1,
      paddingY: '10px',
    },
  },
};
